const properties = [
  {
    id: 1,
    title: "Moderni stan u centru",
    location: "Zagreb, Centar",
    price: 250000,
    bedrooms: 3,
    bathrooms: 2,
    area: 95,
    features: ["Parking", "Lift", "Klima", "Balkon"],
    images: [
      "https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1582268611958-ebfd161ef9cf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ],
    description: "Prostran stan sa panoramskim pogledom na grad...",
    agent: {
      name: "Marko Ivić",
      email: "marko.ivic@nekretnine.com",
      phone: "+385 91 123 4567"
    }
  },
  {
    id: 2,
    title: "Obiteljska kuća s vrtom",
    location: "Zagreb, Novi Zagreb",
    price: 450000,
    bedrooms: 4,
    bathrooms: 3,
    area: 180,
    features: ["Vrt", "Garaža", "Kamin", "Terasa"],
    images: [
      "https://images.unsplash.com/photo-1600585154340-be6161a56a0c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1605146769289-440113cc3d00?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ],
    description: "Prostrana obiteljska kuća u mirnom naselju...",
    agent: {
      name: "Ana Horvat",
      email: "ana.horvat@nekretnine.com",
      phone: "+385 91 765 4321"
    }
  },
  {
    id: 3,
    title: "Luksuzna vila s bazenom",
    location: "Dubrovnik, Lapad",
    price: 1200000,
    bedrooms: 5,
    bathrooms: 4,
    area: 320,
    features: ["Bazen", "Pogled na more", "Vrt", "Home Cinema"],
    images: [
      "https://images.unsplash.com/photo-1613977257363-707ba9348227?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ],
    description: "Raskošna vila s izvanrednim pogledom na more...",
    agent: {
      name: "Ivan Perić",
      email: "ivan.peric@nekretnine.com",
      phone: "+385 99 555 8888"
    }
  },
  {
    id: 4,
    title: "Stan u novogradnji",
    location: "Split, Poljud",
    price: 180000,
    bedrooms: 2,
    bathrooms: 1,
    area: 65,
    features: ["Parking", "Lift", "Balkon"],
    images: [
      "https://images.unsplash.com/photo-1628133287836-40bd5453bed1?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ],
    description: "Novo renoviran stan u blizini mora...",
    agent: {
      name: "Petra Kovač",
      email: "petra.kovac@nekretnine.com",
      phone: "+385 98 123 4567"
    }
  },
  {
    id: 5,
    title: "Kuća na selu",
    location: "Varaždin, okolica",
    price: 95000,
    bedrooms: 3,
    bathrooms: 1,
    area: 120,
    features: ["Velički vrt", "Šupa", "Voćnjak"],
    images: [
      "https://images.unsplash.com/photo-1600566752355-35792bedcfea?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1583608205776-bfd35f0d9f83?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ],
    description: "Idilična seoska kućica savršena za odmor...",
    agent: {
      name: "Tomislav Novak",
      email: "tomislav.novak@nekretnine.com",
      phone: "+385 95 555 1111"
    }
  },
  {
    id: 6,
    title: "Penthouse s pogledom",
    location: "Rijeka, Centar",
    price: 380000,
    bedrooms: 3,
    bathrooms: 2,
    area: 110,
    features: ["Terasa", "Lift", "Parking", "Klima"],
    images: [
      "https://images.unsplash.com/photo-1582407947304-fd86f028f716?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1499793983690-e29b59dea012?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ],
    description: "Luksuzni penthouse s panoramskim pogledom na grad...",
    agent: {
      name: "Maja Horvat",
      email: "maja.horvat@nekretnine.com",
      phone: "+385 91 222 3333"
    }
  },
  {
    id: 7,
    title: "Stan u centru Zagreba",
    location: "Zagreb, Centar",
    price: 180000,
    bedrooms: 2,
    bathrooms: 1,
    area: 65,
    features: ["Parking", "Lift", "Balkon"],
    images: [
      "https://images.unsplash.com/photo-1595526114035-0d45ed16cfbf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
      "https://images.unsplash.com/photo-1631889992044-1f007d1a82d3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80"
    ],
    description: "Prostran stan u samom centru Zagreba...",
    agent: {
      name: "Ivana Horvat",
      email: "ivana.horvat@nekretnine.com",
      phone: "+385 98 765 4321"
    }
  }
];

export default properties;